import { Pipe, PipeTransform } from '@angular/core';

const ms = 1000;
const s = 1 * ms;
const m = 60 * s;
const h = 60 * m;
const d = 24 * h;

const DEFAULT_FORMAT = 'DDd HHh mmm sss';

@Pipe({
    name: 'timeLeft'
})
export class TimeLeftPipe implements PipeTransform {
    transform(timeLeft: number, format: string): string {
        if (!format) {
            format = DEFAULT_FORMAT;
        }

        const days = Math.floor(timeLeft / d);

        timeLeft = timeLeft - days * d;
        const hours = Math.floor(timeLeft / h);

        timeLeft = timeLeft - hours * h;
        const minutes = Math.floor(timeLeft / m);

        timeLeft = timeLeft - minutes * m;
        const seconds = Math.floor(timeLeft / s);

        const matcher = matcherFp({ days, hours, minutes, seconds});
        // const regexp = /\w/;
        const regexp = /(D{1,2}|H{1,2}|m{1,2}|s{1,2})(?!\s)/g;

        if (format) {
            return format.replace(regexp, (match): string => {
                return matcher(match);
            });
        }
    }
}

function pad(value: number): string {
    return (value < 10 ? '0' : '') + value;
}

const handler = {};
handler[''] = (): string => '';
handler['D'] = ({ days }): string => days;
handler['DD'] = ({ days }): string => pad(days);
handler['H'] = ({ hours }): string => hours;
handler['HH'] = ({ hours }): string => pad(hours);
handler['m'] = ({ minutes }): string => minutes;
handler['mm'] = ({ minutes }): string => pad(minutes);
handler['s'] = ({ seconds }): string => seconds;
handler['ss'] = ({ seconds }): string => pad(seconds);

function matcherFp(times): (string) => string {
    return function(match: string): string {
        return handler[match](times);
    };
}
